// extracted by css-extract-rspack-plugin
export default {"question":"_a0c9371","questionTitle":"_4caa79f1","button":"_87c60e9"};